import { createSelector } from 'reselect';
import { RootState } from 'types/root-state';

export const getEnv = createSelector(
	({ env }: RootState) => env,
	env => env
);

export const getOrchestratorHost = createSelector(
	getEnv,
	({ ORCHESTRATOR_HOST }) => ORCHESTRATOR_HOST
);

export const getIsBot = createSelector(
	({ isBot }: RootState) => isBot,
	isBot => isBot
);
